import React from 'react'

const ImagingForm = () => {
  return (
    <div>
      ImagingForm
    </div>
  )
}

export default ImagingForm
